import { useCallback, useMemo, useState } from "react";

import { SnackbarMessageActions } from "../context";
import { SnackbarMessage } from "../types";

export type SnackbarMessageStore = {
  actions: SnackbarMessageActions;
  messages: SnackbarMessage[];
};

export const useSnackbarMessageStore = (): SnackbarMessageStore => {
  const [messages, setMessages] = useState<SnackbarMessage[]>([]);

  const addMessage = useCallback((message: SnackbarMessage) => {
    setMessages((prev) => [...prev, message]);
  }, []);

  const removeMessage = useCallback((message: SnackbarMessage) => {
    setMessages((prev) => prev.filter((m) => m !== message));
  }, []);

  return {
    actions: useMemo(
      () => ({ addMessage, removeMessage }),
      [addMessage, removeMessage],
    ),
    messages,
  };
};
